/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Field, ErrorMessage, useFormikContext, useField } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Input = ({ label, name, type, placeholder, disabled }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField({ name });
  const [date, setDate] = useState(new Date());

  if (type === "date") {
    return (
      <div className="mb-3">
        <label htmlFor={name} className="form-label">
          {label}
        </label>
        <DatePicker
          className="form-control"
          name={name}
          placeholderText={placeholder}
          disabled={disabled}
          selected={(field.value && new Date(field.value)) || null}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onChange={(val) => {
            setDate(val);
            setFieldValue(name, val);
          }}
        />
        <div className="text-danger mt-1">
          <ErrorMessage name={name} />
        </div>
      </div>
    );
  } else {
    return (
      <div className="mb-3">
        <label htmlFor={name} className="form-label">
          {label}
        </label>
        <Field type={type} name={name} placeholder={placeholder} className="form-control" readOnly={disabled} />
        <div className="text-danger mt-1">
          <ErrorMessage name={name} />
        </div>
      </div>
    );
  }
};

export default Input;
